module.exports = __webpack_public_path__ + "img/HomeWithBinacular_PhonePlus-Nobg.72cf4852.png";